<template>
   <div class="row">
    <div class="jewelry-customization-v2">     
      <div class="variations">
      <el-form :model="model" :rules="rules" ref="form">
        <el-form-item prop="stones">
          <input type="hidden" v-model="model.stones"/>
          <div class="filter_box stone_type_filters">
            <ul v-for="(item, index) in stonesdata" :key="index" :data-type='item.type'>
							<li 
                v-for="stone in item.stones" :id="'s' + stone.id" :key="stone.id" 
                :data-value="stone.datavalue"
                :class="classThumbnailMultiple(stone.id, stone.stoneclass, stone.disabled )"
                @click="onSelectMultipleImage(stone)"                
              >
								<div class='filter_item'>
									<span class="filter_img"></span>
									<span class="filter_title">{{stone.title}}</span>
								</div>
							</li>                
            </ul>
          </div>
        </el-form-item>
      </el-form>
			</div>
    </div>
  </div>
</template>

<script>
//import StonesData from './FindJewelry/stonesdata'
const params = new URLSearchParams(window.location.search)

export default {
  data(){
		return { 
      rootClass: "filter_item",
      activeClass: "selected",
      //stonesdata: StonesData,
      multipleSelected: [],
      stones: [],
      limit: 0,
      model: { 
          stones: '',
      },
      rules: {
        stones: [{
          required: true,
          message: 'Please select at least one jewelry stones.',
          trigger: 'change'
        }]
      },
    }
  },
  props: [
    'stonesdata',
  ],
  created() {
    this.URLparams();
  },  
  methods: {
    URLparams() {
      const baseClass = `${this.rootClass}`;
      const activeClass = `${this.activeClass}`;

      this.model.stones = ( params.has('productStones') 	? params.getAll('productStones').toString() : '')

      var arr_stones = {}
        this.model.stones.split(',').forEach(element => {
          arr_stones = { 'id' : parseInt(element)}
      })
      this.multipleSelected = [].concat([ arr_stones ]);

      var parsedobj = this.model.stones.split(',')
      document.addEventListener("DOMContentLoaded", function() {
        parsedobj.forEach(element => {
          var stoneClasses = `#s${element}` 
          var selection = document.querySelector(stoneClasses) !== null;
          if ( selection )
            document.querySelector(stoneClasses).classList.add(`${activeClass}`) 
        });
      })
      return this.model
    },    
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          this.$emit('on-validate', valid, this.model)
          resolve(valid);
        });
      })
    },
    onChange() {
      this.$emit("can-continue", { value: true });
    },
    classThumbnailMultiple(id, stoneclass, isDisabled) {
      const baseClass = stoneclass;
      const baseMultipleClass = `${baseClass} is--multiple`;

      //console.log(isDisabled)
			var stoneClasses = "." + stoneclass
			var selection = document.querySelector(stoneClasses) !== null;

      if (isDisabled) {
        if (selection) {
          if (document.querySelector(stoneClasses).classList.contains('jewelry-disabled') ) {
            return `${baseMultipleClass} jewelry-disabled`;
          }
        }          

      }
      if (this.isExistInArray(id) && !isDisabled) {
        if (selection) {
          if (!document.querySelector(stoneClasses).classList.contains('jewelry-disabled') ) {
            return `${baseMultipleClass} ${this.activeClass}`;
          }
        }          
      }
      return `${baseMultipleClass}`;
    },
    isExistInArray(id) {
      return this.multipleSelected.find(item => {
        return id === item.id;
      });
    },
    removeFromMultipleSelected(id, dontFireEmit) {
      this.multipleSelected = this.multipleSelected.filter(item => {
        return id !== item.id;
      });
      if (!dontFireEmit) {
        this.$emit("onselectmultipleimage", this.multipleSelected);
      }
    },
    resetMultipleSelection() {
      this.multipleSelected = [];
    },
    onSelectMultipleImage(objectImage) {
      var stoneClasses = "." + objectImage.stoneclass
      //updates data if the dom elements were updated by axios
      if (!document.querySelector(stoneClasses).classList.contains('jewelry-disabled')) {
        objectImage.disabled = false
      } 
      if (!objectImage.disabled) {
        if (!this.isExistInArray(objectImage.id)) {
          if (this.limit > 0) {
            if (this.multipleSelected.length < this.limit) {
              this.multipleSelected.push(objectImage);
              this.$emit("onselectmultipleimage", this.multipleSelected);
            } else {
              this.$emit("onreachlimit", this.limit);
            }
          } else {
            this.multipleSelected.push(objectImage);
            this.$emit("onselectmultipleimage", this.multipleSelected);
          }
        } else {
          this.removeFromMultipleSelected(objectImage.id, true);
          this.$emit("onselectmultipleimage", this.multipleSelected);
        }
      } else {
        //console.log(objectImage.stoneclass + ' has jewelry-disabled and cannot be selected.' )
      }
      this.stones = [];
      var parsedobj = JSON.parse(JSON.stringify(this.multipleSelected))
      parsedobj.forEach(element => {
        if (!document.querySelector(stoneClasses).classList.contains('jewelry-disabled')) {
          this.stones.push(element.id)
        }         
      });

      this.stones = this.stones.filter(function( element ) {
        return element !== null && element !== undefined;
      }); 
      //console.log(this.model.stones)
      if (this.model.stones != '') //if model.stones is not empty  
        this.model.stones = this.model.stones.concat(',',JSON.parse(JSON.stringify(this.stones)).join(','))
      else
        this.model.stones = JSON.parse(JSON.stringify(this.stones)).join(',')      
    }
  },
}
</script>
<style lang="scss" scoped>
  .wizard-tab-container { text-align: left; }
</style>